<template>
    <!-- Topbar Start -->
    <div class="navbar-custom">
        <ul class="list-unstyled topbar-right-menu float-right mb-0">
            <client-apps-dropdown v-show="currentWebsiteId"></client-apps-dropdown>
            <li class="dropdown notification-list">
                <a
                    class="nav-link dropdown-toggle nav-user arrow-none mr-0"
                    data-toggle="dropdown"
                    href="#"
                    role="button"
                    aria-haspopup="false"
                    aria-expanded="false"
                >
                    <span class="account-user-avatar">
                        <span class="initial">{{ myInitial }}</span>
                    </span>
                    <span>
                        <span class="account-user-name">{{ myName }}</span>
                    </span>
                </a>
                <div
                    class="dropdown-menu dropdown-menu-right dropdown-menu-animated topbar-dropdown-menu profile-dropdown"
                >
                    <!-- item-->
                    <div class="dropdown-header noti-title">
                        <h6 class="text-overflow m-0">Welcome!</h6>
                    </div>

                    <!-- item-->
                    <a
                        @click="showMyInfo()"
                        href="javascript:void(0);"
                        class="dropdown-item notify-item"
                    >
                        <i class="mdi mdi-account-circle mr-1"></i>
                        <span>My Account</span>
                    </a>

                    <!-- item-->
                    <a
                        @click="logout()"
                        href="javascript:void(0);"
                        class="dropdown-item notify-item"
                    >
                        <i class="mdi mdi-logout mr-1"></i>
                        <span>Logout</span>
                    </a>
                </div>
            </li>
        </ul>
        <button @click.prevent="toggleMenu()" class="button-menu-mobile open-left disable-btn">
            <i class="mdi mdi-menu" id="button-menu-mobile-toggle"></i>
        </button>
        <div class="app-search">
            <router-link to="/" class="btn btn-outline-secondary" v-if="$route.name != 'home'">
                <i class="dripicons-arrow-thin-left"></i>
                Home
            </router-link>
        </div>
    </div>
    <!-- end Topbar -->
</template>

<script>
// import axios from "axios";
import user from "@/client/api/user";

import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { EventBus } from "@/utils/EventBus";

// import shared_api from "../../api/shared_api";
import ClientAppsDropdown from "@/client/components/ClientAppsDropdown.vue";

// import CsrfMixin from "../../utils/CsrfMixin";

export default {
    components: {
        ClientAppsDropdown
    },
    data() {
        return {
            // timer: null,
            // Admin info modal
            // my_info: {},
        };
    },
    // mixins: [CsrfMixin],
    methods: {
        toggleMenu() {
            $("body").toggleClass("sidebar-enable");
        },
        async logout() {
            // this.$refs.logoutForm.submit();
            try {
                let res = await this.tryLogout();
                if (res.data && res.data.status == "ok") {
                    // this.setShowingLoginModal(true);
                }
            } catch (e) {}
        },
        showMyInfo() {
            EventBus.$emit("show-modal", "user-info-modal");
        },
        ...mapActions("user", ["getMyInfo"]),
        ...mapActions("auth", ["tryLogout", "refreshState"]),
        ...mapMutations("auth", ["setShowingLoginModal"])
    },
    computed: {
        logoutUrl() {
            return "/logout";
        },
        // myName() {
        //     // return this.my_info.name;
        //     // return this.adminName;
        //     return "Samuel Chan";
        // },
        myInitial() {
            let initial = "";
            let name = this.myName;
            if (name) {
                let parts = name.split(" ");

                if (parts[0]) {
                    initial += parts[0][0];
                }

                if (parts.length > 1) {
                    initial += parts[parts.length - 1][0];
                }

                return initial.toUpperCase();
            }
        },
        ...mapState(["currentWebsiteId"]),
        ...mapState("user", { myName: "name" })
    },
    created() {
        // this.timer = setInterval(() => {
        //     shared_api.ping().then(() => {
        //         // console.log("ping");
        //     });
        // }, 1000 * 60 * 15);
        // this.getMyInfo();
        // this.loadMyInfo();
        // EventBus.$on("refresh-myinfo", this.loadMyInfo);
        this.getMyInfo();
    },
    beforeDestroy() {
        // clearInterval(this.timer);
        // EventBus.$off("refresh-myinfo", this.loadMyInfo);
    }
};
</script>

<style lang="scss">
.client-apps-dropdown {
    padding: rem-calc(32/2) 0;
    padding-right: rem-calc(24);
}

.nav-user {
    display: flex !important;
    align-items: center;
}

.nav-user .account-user-avatar .initial {
    display: inline-block;
    width: rem-calc(32);
    height: rem-calc(32);
    background-color: $primary-color;
    color: #fff;
    border-radius: 50%;
    line-height: rem-calc(32);
    text-align: center;
    overflow: hidden;
}

.modal-admin-info {
    .reset-password.alert {
        margin-bottom: 0;

        h5 {
            border-bottom: 1px solid mix(#000, #f9fbfc, 10%);
            padding-bottom: rem-calc(10);
            margin-bottom: rem-calc(20);
        }
    }
}
</style>